import { Filters, SearchInput } from "components/molecules";

import {
	ComplexFilterItem,
	ComplexFilterType,
	SearchComplexFilter,
} from "interfaces/filters";

interface Props {
	filters: ComplexFilterItem[];
	onChange: (filter: ComplexFilterItem) => void;
	onCreate: (filter: ComplexFilterItem) => void;
	onDelete: (filter: ComplexFilterItem) => void;
	onClear: () => void;
	searchPlaceholder?: string;
	hideSearch?: boolean;
	options: ComplexFilterType[];
}

const ComplexFilterPanel = (props: Props): JSX.Element => {
	const {
		filters,
		onChange,
		searchPlaceholder,
		onDelete,
		onCreate,
		onClear,
		options,
	} = props;

	const renderSearch = () => {
		const searchFilter = filters.find(
			(filter: ComplexFilterItem) => filter.type === ComplexFilterType.SEARCH
		) as SearchComplexFilter;

		return searchFilter ? (
			<SearchInput
				filterData={searchFilter}
				changeFilter={onChange}
				placeholder={searchPlaceholder || ""}
			/>
		) : null;
	};

	return (
		<div className="flex items-start justify-between w-full py-[15px] relative flex-wrap gap-[15px] md:flex-col md:gap-3 sm:gap-2.5">
			<Filters
				filters={filters}
				changeFilter={onChange}
				onDelete={onDelete}
				onCreate={onCreate}
				onClear={onClear}
				options={options}
			/>
			{renderSearch()}
		</div>
	);
};

export default ComplexFilterPanel;
